<template>
    <div>
    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 600px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <h1 class="display-2 text-white">Hello {{userinfo.FullName}}</h1>
                        <p class="text-white mt-0 mb-5">This is your profile page.</p>                       
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-5 order-xl-2 mb-5 mb-xl-0">

                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                     <img v-if="userinfo.Passport" alt="" :src="$store.state.auth.baseurl + userinfo.Passport.substr(1)" class="rounded-circle" />
                        <img v-else src="img/brand/loguser.png" alt="" class="rounded-circle" />                                   
                                </div>
                            </div>
                        </div>
                       
                        <div class="card-body pt-0 pt-md-4">
                           <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                                        <div>
                                            <span class="heading">Email</span>
                                            <span class="description"> {{userinfo.EmailAddress}}</span>
                                        </div>
                                        <div>
                                            <span class="heading">Phone Number</span>
                                            <span class="description"> {{userinfo.PhoneNo}}</span>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                            <div class="text-center">
                                <h3>
                                   {{userinfo.FullName}}
                                </h3>                               
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-7 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="align-items-center">
                                <h3 class="mb-0">Change Password</h3>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent="changepassword">                               
                                <div class="pl-lg-4">                                    
                                    <div class="form-horizonal">
                                        <div class="form-group">
                                            <base-input alternative=""
                                                        label="Old Password"
                                                        placeholder="Old Password"
                                                        input-classes="form-control-alternative"
                                                        type="password"
                                                        v-model="OldPasswordval"
                                            />
                                        </div> 
                                         <div class="form-group">
                                            <base-input alternative=""
                                                        label="New Password"
                                                        placeholder="New Password"
                                                        input-classes="form-control-alternative"
                                                        type="password"
                                                        v-model="NewPasswordval"
                                            />
                                        </div>
                                        <div class="form-group">
                                            <base-input alternative=""
                                                        label="Retype Password"
                                                        placeholder="Retype Password"
                                                        input-classes="form-control-alternative"
                                                        type="password"
                                                        v-model="ReTypePasswordval"
                                            />
                                        </div>                                       
                                    </div>                                   
                                </div>
                                <div class="text-center">
                                    <button type="submit" class="btn btn-primary btn-block my-3">Submit</button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import swal from 'sweetalert'
  export default {
    name: 'user-profile',
    data() {
      return {
            userinfo: null,
            OldPasswordval: '',
            NewPasswordval: '', 
            ReTypePasswordval:'',
            onloader: 'none'
      }
    },
    methods:{
         changepassword: function () {           
            let OldPassword=this.OldPasswordval;
            let NewPassword=this.NewPasswordval;
            let ReTypePassword=this.ReTypePasswordval;
            if(NewPassword==ReTypePassword){
                this.onloader = 'flex'
                this.$store.dispatch('changepassword', {OldPassword,NewPassword})
                .then(() => {  
                    this.onloader = 'none'                 
                   swal({
                            title: "Success!",
                            text: 'Changed Successfully',
                            icon: "success",
                            button: "Ok",
                        });
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.checkresponse(err.response.data);
                })
            }else{
                swal({
                    title: "Oops!",
                    text: "Password Mismatched",
                    icon: "error",
                    button: "Ok",
                });
            }
           
        },
        getuser: function () {
            this.onloader = 'flex';
            this.$store.dispatch('getuser')
                .then((resp) => {
                    this.userinfo = resp;
                    this.onloader = 'none';
                })
                .catch(err => {
                    console.log(err);
                    this.onloader = 'none';
                    this.$store.dispatch('logout')
                    this.$router.push('/login')
                })
        },
        checkresponse: function (resp) {
            if (resp === "Access Expired" || resp === "Invalid Credential") {
                this.$store.dispatch('logout');
                this.$router.push('/login')
            } else {
                swal({
                    title: "Oops!",
                    text: resp,
                    icon: "error",
                    button: "Ok",
                });
            }
        }
    },
    mounted(){
        this.getuser();
    }
  };
</script>
<style></style>
